import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
// Types

// Mixins
import mixins from 'vue-typed-mixins';
import { typedModal } from '../../utils/typedModals';

// Utils
import { preventDefault, valueFromInput } from '../../utils/jsxHelpers';
import { forEachKey, mapEachKey } from '../../utils/hasKey';

// Enums
import { Modals } from '../../enums/Modals';
export const LinkOptionsModalEvents = typedModal();

// Enuming and mapping
var Naming;
(function (Naming) {
  Naming["post"] = "posts";
  Naming["page"] = "pages";
  Naming["product"] = "products";
  Naming["blogCategory"] = "blogCategories";
  Naming["productCategory"] = "productCategories";
})(Naming || (Naming = {}));
const labeling = {
  post: 'Posts',
  page: 'Pages',
  product: 'Products',
  blogCategory: 'Blog Categories',
  productCategory: 'Product Categories'
};

// Component
const LinkOptionsModal = mixins(LinkOptionsModalEvents).extend({
  data() {
    const groups = {
      posts: [],
      pages: [],
      products: [],
      blogCategories: [],
      productCategories: []
    };
    const forms = {
      post: '',
      page: '',
      product: '',
      blogCategory: '',
      productCategory: ''
    };
    return {
      form: {
        name: '',
        rel: '',
        href: '',
        target: '',
        ...forms,
        // category stays here just because of backwards compatibility, now its called blogCategory
        category: '',
        formattedPath: ''
      },
      ...groups,
      onConfirm: null
    };
  },
  computed: {
    pageSelects() {
      const h = this.$createElement;
      return mapEachKey(labeling, group => h("div", {
        "class": "p-2",
        "key": group
      }, [h("label", {
        "attrs": {
          "for": Naming[group]
        },
        "class": "inline-block w-2/5 align-top"
      }, [labeling[group]]), h("select", {
        "attrs": {
          "id": Naming[group]
        },
        "class": "inline-block w-3/5 rounded-sm px-2 py-1 bg-gray-200 shadow-inner",
        "domProps": {
          "value": this.form[group]
        },
        "on": {
          "input": valueFromInput(v => {
            this.form[group] = v;
            this.resetSelects(group);
          })
        }
      }, [h("option", {
        "attrs": {
          "value": ""
        }
      }, ["Select ", labeling[group]]), this[Naming[group]].map(term => h("option", {
        "key": term.slug,
        "domProps": {
          "value": term.slug,
          "selected": this.form[group] === term.slug
        }
      }, [term.title]))])]));
    }
  },
  methods: {
    beforeOpen(props) {
      const p = props.params;
      this.onConfirm = p.onConfirm;
      !p.link ? forEachKey(this.form, key => this.form[key] = '') : forEachKey(p.link, key => {
        // lol typescript...
        if (key === 'target') {
          var _p$link;
          this.form[key] = ((_p$link = p.link) === null || _p$link === void 0 ? void 0 : _p$link[key]) || '';
        } else if (key === 'blogCategory') {
          var _p$link2, _p$link3;
          //Old 'blogCategory' property was called 'category', thats why we need to reassign it now
          this.form[key] = ((_p$link2 = p.link) === null || _p$link2 === void 0 ? void 0 : _p$link2[key]) || ((_p$link3 = p.link) === null || _p$link3 === void 0 ? void 0 : _p$link3.category) || '';
        } else if (key === 'category') {
          //Reset old property
          this.form.category = '';
        } else {
          var _p$link4;
          this.form[key] = ((_p$link4 = p.link) === null || _p$link4 === void 0 ? void 0 : _p$link4[key]) || '';
        }
      });
      this.loadLists();
    },
    async loadLists() {
      const productCategories = await this.$api.product.web.category.filter({
        filters: [],
        sort: {
          param: 'id',
          order: 'asc'
        },
        tree: false
      });
      if (productCategories.errored) return;
      this.productCategories = productCategories.data.records.map(category => ({
        id: category.id,
        slug: category.slug,
        title: category.name,
        typeSlug: 'category'
      }));
      const termSearches = await this.$api.cms.finder.searchSlug();
      if (termSearches.errored) return;
      this.posts = termSearches.data.posts.post || [];
      this.pages = termSearches.data.posts.page || [];
      this.products = termSearches.data.products;
      this.blogCategories = termSearches.data.terms.category;
    },
    resetSelects(exclude) {
      forEachKey(labeling, key => key !== exclude && (this.form[key] = ''));
      if (exclude) {
        const v = this.form[exclude];
        const pathing = {
          product: '/product/' + v,
          page: '/' + v,
          blogCategory: `${this.localePath(this.$Page.Blog)}/${v}`,
          productCategory: `${this.localePath(this.$Page.Shop)}/${v}`,
          post: '/' + v
        };
        this.form.href = '';
        this.form.formattedPath = pathing[exclude];
      } else {
        this.form.formattedPath = this.form.href;
      }
    },
    submit() {
      var _this$onConfirm;
      (_this$onConfirm = this.onConfirm) === null || _this$onConfirm === void 0 ? void 0 : _this$onConfirm.call(this, {
        ...this.form
      });
      this.$modal.hide(Modals.LinkOptions);
    }
  },
  render() {
    const h = arguments[0];
    return h("modal", _mergeJSXProps([{
      "attrs": {
        "name": Modals.LinkOptions,
        "id": Modals.LinkOptions,
        "clickToClose": false,
        "height": "auto"
      }
    }, {
      "on": {
        'before-open': this.beforeOpen
      }
    }]), [h("form", {
      "attrs": {
        "id": Modals.LinkOptions
      },
      "class": "p-2",
      "on": {
        "submit": preventDefault(() => this.submit())
      }
    }, [h("div", {
      "class": "p-2"
    }, [h("label", {
      "attrs": {
        "for": "link-name"
      },
      "class": "inline-block w-2/5 align-top"
    }, ["Name"]), h("input", {
      "attrs": {
        "id": "link-name",
        "type": "text"
      },
      "class": "inline-block w-3/5 rounded-sm px-2 py-1 bg-gray-200 shadow-inner",
      "domProps": {
        "value": this.form.name
      },
      "on": {
        "input": valueFromInput(v => this.form.name = v)
      }
    })]), this.pageSelects, h("div", {
      "class": "p-2"
    }, [h("label", {
      "attrs": {
        "for": "external-link"
      },
      "class": "inline-block w-2/5 align-top"
    }, ["External link"]), h("input", {
      "attrs": {
        "id": "external-link",
        "type": "text"
      },
      "class": "inline-block w-3/5 rounded-sm px-2 py-1 bg-gray-200 shadow-inner",
      "domProps": {
        "value": this.form.href
      },
      "on": {
        "input": valueFromInput(v => {
          this.form.href = v;
          this.resetSelects();
        })
      }
    })]), h("div", {
      "class": "flex justify-end p-2"
    }, [h("button", {
      "attrs": {
        "type": "button"
      },
      "class": "text-gray-800 border border-gray-300 h-8 bg-white px-4 ml-4 rounded-sm hover:bg-gray-100 transition-colors duration-150",
      "on": {
        "click": () => this.$modal.hide(Modals.LinkOptions)
      }
    }, [this.$at('core.action.cancel')]), h("button", {
      "class": "h-8 text-white bg-blue-600 px-4 ml-3 rounded-sm transition-colors duration-150 hover:bg-blue-700",
      "attrs": {
        "type": "submit"
      }
    }, [this.$at('core.action.save')])])])]);
  }
});
export default LinkOptionsModal;